

import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyPin } from '../../Services/authService';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import Cookies from 'js-cookie';
  import Loader from "../../Loader";


const PinInput = ({ inputRefs, onPinChange, onSubmit }) => {
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const [focusedIndex, setFocusedIndex] = useState(0);

  const handleChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    const fullPin = newPin.join("");
    if (onPinChange) onPinChange(fullPin);

    // Move to next input
    if (value !== "" && index < 5) {
      inputRefs.current[index + 1].current.focus();
      setFocusedIndex(index + 1);
    }

    // Auto-submit when 6 digits are entered
    if (fullPin.length === 6 && onSubmit) {
      onSubmit(fullPin);
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === "Backspace" && index > 0 && pin[index] === "") {
      inputRefs.current[index - 1].current.focus();
      setFocusedIndex(index - 1);
    }
  };

  return (
    <div className="flex justify-center md:mb-4 mb-2 items-center relative">

      {/* Jump Animation CSS */}
      <style>
        {`
          .jump {
            display: inline-block;
            animation: jump 0.35s ease;
          }
          @keyframes jump {
            0% { transform: translateY(0); }
            50% { transform: translateY(-6px); }
            100% { transform: translateY(0); }
          }
        `}
      </style>

      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <div className="relative">
            <input
              ref={inputRefs.current[index]}
              type="password"
              maxLength={1}
              value={value}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleBackspace(index, e)}
              onFocus={() => setFocusedIndex(index)}
              className="border border-blue-500 md:w-10 md:h-10 w-9 h-10 text-center mx-1 rounded shadow-lg shadow-blue-600"
              autoFocus={index === 0}
            />

            {focusedIndex === index && (
              <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xl jump text-green-800">
                ✔
              </span>
            )}
          </div>

          {index === 2 && (
            <span className="md:mt-2 text-sky-500 ml-1">&ndash;</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};


const ModalWithPinInput = ({ isModalOpen, toggleModal, tempToken }) => {
  const inputRefs = useRef(Array.from({ length: 6 }).map(() => React.createRef()));
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (currentPin = pin) => {
    if (currentPin.length !== 6) {
      setError("Please enter a 6-digit PIN.");
      return;
    }

    setError("");
    setIsLoading(true); 

    try {
      const result = await verifyPin(currentPin, tempToken);

      if (result.success) {
       // showSuccessToast(result.message);
        Cookies.set("authTokenUser", result.token);
        toggleModal();
        navigate("/Dashboard");
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      showErrorToast("Server error occurred.");
    } finally {
      setIsLoading(false); 
    }
  };

  return (
    isModalOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        
        {/* Loader Overlays Above Modal */}
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center z-50">
            <Loader />
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg w-[78%] md:w-1/3 z-40">
          <div className="bg-gradient-to-r from-indigo-900 to-blue-700 text-white text-center md:py-4 p-2 rounded-t-lg">
            <span className="text-md md:text-xl">Enter 6 Digit PIN</span>
          </div>

          <div className="p-4">
            <PinInput inputRefs={inputRefs} onPinChange={setPin} onSubmit={handleSubmit} />
            {error && <div className="text-red-500 mt-2 text-center">{error}</div>}
          </div>

        <span className="font-semibold text-blue-900 text-center block mt-2 text-lg">
  PIN will verify automatically
</span>

          <div className="flex justify-center md:p-6 p-2">
            <button
              type="button"
              className="bg-red-900 shadow-xl shadow-red-600 bg-gradient-to-r from-red-400 
              to-red-900 text-white md:text-xl p-1 rounded-md hover:from-red-900 hover:to-red-400"
              onClick={toggleModal}
              disabled={isLoading}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );
};


export default ModalWithPinInput;
